module.exports = __webpack_public_path__ + "static/media/benefits_layette.a0a3f625.svg";